import React from 'react'
import PropTypes from 'prop-types'
import { Link, withPrefix } from 'gatsby'

import useScript from '../../utils/useScript'
import Address from "../address"
import * as style from './globe.module.scss'

const GlobeViz = ({ office }) => {
  useScript(`https://cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/TweenMax.min.js`)
  useScript(withPrefix(`css_globe_PerspectiveTransform.js`))
  useScript(withPrefix(`globeES5.js`))

  if (office) {
    const loc = office.OfficeAddress.address[0].location
    window.goTo(loc.latitude, loc.longitude)
  }

  return (
    <div className={style.colGlobeInner}>
      <div className="world" style={{position: 'absolute', width: '100%', height: '100%', cursor: 'pointer'}}>
        <div className="world-globe" style={{position: 'absolute', left: '50%', top: '50%'}}>
          <div className="world-globe-pole" style={{position: 'absolute', width: '530px', height: '530px', left: '-265px', top: '-265px', borderRadius: '50%', backgroundColor: '#41414b'}}></div>
          <div className="world-globe-doms-container"></div>
          <div className="world-globe-halo" style={{position: 'absolute', left: '50%', top: '50%', width: '730px', height: '715px', marginLeft: '-368px', marginTop: '-350px'}}></div>
        </div>
      </div>

      { office && (
      <div className={style.activeOffice}>
        <strong>{office.title}</strong>
        <Address addresses={office.OfficeAddress.address} addressLabel='' showPhone={false} showEmail={false} />
        <Link to={office.link}>Dowiedz się więcej &rarr;</Link>
      </div>
      )}
    </div>
  )
}

GlobeViz.propTypes = {
  office: PropTypes.object
}

export default GlobeViz
